import React, { useState } from 'react';

// import { LinkedIn } from 'react-linkedin-login-oauth2'
import axios from 'axios'

import { Window } from "../../../contexts"
import { LinkHelper } from "../../../helpers"
import { Loading } from "../../../components"

const Linkedin = props => {
    const [ data, setData ] = useState(props.data)
    const [ status, setStatus ] = useState('initial')

    const handleSuccess = (data) => {
        setStatus('loading')

        axios.get('/api/linkedin/member', {
            params: {
                code: data.code
            }
        }).then(response => {
            setStatus('loaded')

            if (response.data.id) {
                const providerData = {
                    'type': 'linkedin',
                    'provider_id': response.data.id,
                    'email': response.data.email,
                    'first_name': response.data.first_name,
                    'last_name': response.data.last_name,
                    'profile_image_url': response.data.profile_image_url,
                    'access_token': response.data.access_token
                };

                setData(providerData)
                props.onSuccess(providerData)
            }
        });
    }

    const handleFailure = (error) => {}

    return (
        <>
            {/* {status !== 'loading' && (
                <LinkedIn
                    clientId={Window.LINKEDIN_CLIENT}
                    scope={'r_emailaddress,r_liteprofile'}
                    onFailure={handleFailure}
                    onSuccess={handleSuccess}
                    className="linkedin"
                    style={{}}
                    redirectUri={LinkHelper.link('/auth/linkedin/redirect')}
                >
                    Sign in with Linkedin
                </LinkedIn>
            )} */}

            {status === 'loading' && <Loading type="small" />}
        </>
    )
};

export default Linkedin;